import type { MenuCategory } from '../categories/menuCategory';

/**
 * @returns a filter string to be used as a static filter
 */
export const buildRootTypeFilter = (
  categories: Array<MenuCategory | string | undefined> = []
) => {
  return categories
    .filter((cat) => cat && !['featured', 'all', 'jane-gold'].includes(cat))
    .map((cat) => `root_types:'${cat === 'specials' ? 'sale' : cat}'`)
    .join(' OR ');
};
